import { Link } from "react-router-dom";
import '../styles/terms.css';
import React, { useEffect, useState } from 'react';
import HeaderFFF from '../components/HeaderFFF'
import Header from '../components/Header'
import Footer from "../components/Footer";

export default function Terms() {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1000);
    
        useEffect(() => {
            const handleResize = () => {
                setIsMobile(window.innerWidth <= 991);
            };
    
            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }, []);
    
        return(
            <>
            {isMobile ? <Header /> : <HeaderFFF />}
                <div className="terms-container">
                    <div className="terms-box">
                        <h2>Terms of Use</h2>
                        <p>The materials on this website are made available by us for informational purposes only and do not constitute legal advice. The transmission and receipt of information contained on the website do not form or constitute a solicitor-client relationship. Persons receiving the information on this website should not act upon the information without seeking professional legal counsel. The materials on this website may not reflect the most current legal developments and should not be considered an indication of future results.
                                            <br/><br/>
Contacting us does not create a solicitor-client relationship. Please do not send any confidential information to us until such time a solicitor-client relationship has been established.</p>
                    </div>
                    <div className="terms-box">
                        <h2>Links to Third Party Websites</h2>
                        <p>We have provided certain links to websites not maintained by us as a convenience. If you follow such links then you will leave our website. The inclusion of such links does not imply recommendation, approval or endorsement by us of the linked websites. The linked websites are not under our control and we are not responsible for the contents of the linked websites or any links contained in the linked website.</p>
                    </div>
                </div>
            <Footer />
        </>
    );
}